import React, { useEffect, useState } from "react";
import * as styles from "./InputErrorMessage.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { nl2br } from "../../utils/helper";
import SlideDownUp from "../SlideDownUp";

const InputErrorMessage = ({ msg, show = false, className }) => {
	const [errorMsg, setErrorMsg] = useState("");
	const [showError, setShowError] = useState(show);

	const inputErrorMessageClassName = classNames({
		[styles["input-error-message"]]: true,
		[className]: !!className,
	});

	useEffect(() => {
		if (msg) {
			setErrorMsg(msg);
		}

		setShowError(show);
	}, [show, msg]);

	return (
		<SlideDownUp show={showError}>
			<div className={inputErrorMessageClassName}>{nl2br(errorMsg)}</div>
		</SlideDownUp>
	);
};

InputErrorMessage.propTypes = {
	show: PropTypes.bool,
	msg: PropTypes.string,
};

export default InputErrorMessage;
